import React from "react";
import { Button, TextField } from "@mui/material";

const AllocatePopup = ({
  open,
  onClose,
  tempAllocateToValue,
  setTempAllocateToValue,
  allocateToValue,
  handleCloseAllocatePopup,
  handleConfirmAllocate,
}) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          width: "400px",
          maxWidth: "90%",
        }}
      >
        <div
          style={{
            backgroundColor: "var(--bg)",
            color: "white",
            padding: "1rem 2rem",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            fontWeight: "bold",
            fontSize: "1.25rem",
            textAlign: "center",
          }}
        >
          Allocate SIM
        </div>

        <div style={{ padding: "2rem" }}>
          <TextField
            fullWidth
            label="Allocate To"
            value={tempAllocateToValue}
            onChange={(e) => setTempAllocateToValue(e.target.value)}
            placeholder="Enter allocation details"
            variant="outlined"
            autoFocus
          />

          {allocateToValue && (
            <div
              style={{
                marginTop: "1rem",
                padding: "0.75rem",
                backgroundColor: "#e7f3ff",
                borderRadius: "4px",
                fontSize: "0.9rem",
                color: "#4151e0",
                border: "1px solid #4151e0",
              }}
            >
              Currently Allocated To: <strong>{allocateToValue}</strong>
            </div>
          )}
        </div>

        <div
          style={{
            padding: "1rem 2rem 2rem",
            display: "flex",
            gap: "1rem",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="outlined" onClick={handleCloseAllocatePopup}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmAllocate}
            disabled={!tempAllocateToValue || !tempAllocateToValue.trim()}
            style={{
              backgroundColor: "#4151e0",
              color: "white",
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AllocatePopup;